import React from "react";
import { Modal,ProgressBar,Spinner } from "react-bootstrap";

function QuestionSubmitModal({
  confirmProgressModalOpen,
  onCloseConfirmProgressModal,
  uploadProgress,
  videoUploadMessage,
  onNextClick,
  nextEnabled,
  onPauseClick,
}) {
  return (
    <Modal
      size="lg"
      show={confirmProgressModalOpen}
      className="common-modal"
      style={{ marginTop: "250px" }}
      onHide={onCloseConfirmProgressModal}
    >
      <Modal.Body className="pt-4 w-100">
        <ProgressBar now={uploadProgress} max={100} />
        <div className="mt-2">
          <span className="text-grey-4 fs-smallest d-inline-block w-100">
            {videoUploadMessage}
          </span>
        </div>
        {uploadProgress === 100 ? (
          <ul className="d-flex align-items-center justify-content-between justify-content-md-end">
            <li>
              <button
                className="btn btn-primary"
                onClick={() => {onNextClick();}}
                disabled={!nextEnabled}
              >
                {!nextEnabled ? (
                  <Spinner
                    animation="border"
                    variant="primary"
                    className="text-white"
                  />
                ) : (
                  "Next"
                )}
              </button>
            </li>

            {/* <li>
              <button
                className="btn btn-secondary ml-2"
                onClick={() => onPauseClick()}
                disabled={!nextEnabled}
              >
                {!nextEnabled ? (
                  <Spinner
                    animation="border"
                    variant="primary"
                    className="text-white"
                  />
                ) : (
                  "Take a break"
                )}
              </button>
            </li> */}
          </ul>
        ) : null}
      </Modal.Body>
    </Modal>
  );
}

export default QuestionSubmitModal;
